<span class="autocomplete-container md-inputfield">
  <p-autoComplete
    ngModel
    #autocomplete
    [style]="{'width':'100%'}"
    [inputStyle]="{'width':'100%'}"
    name="{{autocompleteName}}"
    field="nome"
    [(ngModel)]="itemSelecionado"
    [suggestions]="resultset"
    [dropdown]="true"
    [size]="resultsetMaxSize"
    [forceSelection]="true"
    [tabindex]=2
    [required]="obrigatorio"
    [disabled]="bloqueado || formDisabled"
    (completeMethod)="search($event)"
    (onBlur)="onBlur($event)"
    (onSelect)="onSelect($event)"
    (onClear)="onClear()">

    <ng-template let-paciente pTemplate="item">
      <div class="ui-helper-clearfix">
        <div>{{ paciente.nome }}</div>
        <div class="autocomplete-paciente-info-container">
          <label 
            class='texto-cinza autocomplete-paciente-item-data-nascimento' 
            title='Data de nascimento'>{{ paciente.dataNascimentoDiaMesAno }}
          </label>
          <label class='texto-cinza autocomplete-paciente-item-idade'>
            ({{ paciente.idadePorExtenso }})
          </label>
        </div>
      </div>
    </ng-template>

  </p-autoComplete>
  <label>{{placeholder}}</label>
</span>

<!-- <span class="autocomplete-paciente-atalho-novo-paciente-container" *ngIf="exibirAtalhoNovoPaciente">
  <i class="material-icons texto-cinza-claro click icone-novo-paciente (click)=irParaCadastroDePaciente()">person_add</i>
</span> -->


<!-- Autocomplete Habilitado -->
<div class="autocomplete-paciente-info-container">
  <ng-container *ngIf="exibirAtalhoNovoPaciente">
    <span 
      *ngIf="exibirAtalhoNovoPaciente"
      class="autocomplete-paciente-atalho-novo-paciente-container"
      (click)="irParaCadastroDePaciente()"
      title="Cadastrar novo paciente">
      <i class="material-icons-outlined texto-cinza-claro click icone-novo-paciente">person_add</i>
    </span>
  </ng-container>

  <ng-container *ngIf="(exibirInformacoesAdicionais && itemSelecionado)">
    <a 
       class='autocomplete-paciente-item-icon-popup texto-cinza-claro' 
       *ngIf="itemSelecionado.id"
       onclick="window.open(this.href, 'sumario_paciente', 'resizable=yes, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=10, top=10'); return false;"
       title="Ver paciente"
       href='/homecare/sumario-paciente/{{itemSelecionado.id}}?standalone=true'>
       <label class="material-icons click autocomplete-paciente-item-icon-popup">
        open_in_new
      </label>
    </a>
  
    <label 
      class='texto-cinza autocomplete-paciente-item-data-nascimento' 
      title='Data de nascimento'>{{ itemSelecionado.dataNascimentoDiaMesAno }}
    </label>
    <label 
      *ngIf="itemSelecionado.idadePorExtenso"
      class='texto-cinza autocomplete-paciente-item-idade'
      title="Idade">
      ({{ itemSelecionado.idadePorExtenso }})
    </label>
  </ng-container>
</div>

